import { type Collaborators } from './types';

export const types = {
  RECEIVE_COLLABORATORS: 'quotes/collaborators/RECEIVE_COLLABORATORS',
  SET_MODAL_STATUS: 'quotes/collaborators/SET_MODAL_STATUS',
};

export const receiveCollaborators = (payload: Collaborators) => ({
  type: types.RECEIVE_COLLABORATORS,
  payload,
});

export const setModalStatus = (payload: { isOpened: boolean }) => ({
  type: types.SET_MODAL_STATUS,
  payload,
});
